// Utils
import { isError } from './isError';
// Types
import { ErrorNames } from './ErrorNames';
/**
 * @description Decides if the value is an abort error
 *
 * @param {unknown} valueToCheck The value to check
 * @returns {boolean} Whether or not the value is an abort error
 */
export var isAbortError = function (valueToCheck) { return isError(valueToCheck) && valueToCheck.name === ErrorNames.ABORT; };
//# sourceMappingURL=isAbortError.js.map